module.exports = __webpack_public_path__ + "img/files.d7832240.png";